module.exports = __webpack_public_path__ + "img/modal-folios-upload.c559b4db.svg";